import { FC } from "react"


export type TagBubbleProps = {
    bubbleText: string,
}

const bubbleColors: {
  [key: string]: string;
} = {
  art: '#f2c0fa',
  philosophy: '#e7a0ffff',
  music: '#f2c0fa',
  local: '#9de8ffff',
  noise: '#d67272ff',
  events: '#9de8ffff',
  news: '#9e9e9eff',
  woowoo: '#e7a0ffff',
  default: '#d2fac0'
} 

const getBubbleColor = (bubbleText: string): string => 
  bubbleColors[bubbleText]
  || Object.entries(bubbleColors).find(entry => bubbleText.startsWith(entry[0]))?.[1]
  || bubbleColors.default

const TagBubble: FC<TagBubbleProps> = ({bubbleText}) => {
    const bubbleColor = getBubbleColor(bubbleText)
    return (
    <span className="align-middle mx-1 px-2 text-xs bg-indigo-200 rounded" style={{backgroundColor: bubbleColor}}
            >
              {bubbleText}
            </span>
    )
}

export default TagBubble